'use strict';

const _ = require('lodash');

const Container = require('./Container');

/**
 * Clase contenedora de campos. Es una especialización de {@link Structure.Container} en la que todos sus hijos son
 * instancias de {@link Structure.Field}
 * @extends Container
 * @abstract
 * @memberOf Structure
 */
class FieldsContainer extends Container {
    /**
     * Constructor de la clase
     * @param  {object} definition Definición específica del contenedor
     */
    constructor(definition = {}) {
        super(definition);
        this.fields = definition.fields || [];
    }

    /** @inheritdoc */
    get() {
        const definition = super.get();

        definition.fields = this.fields;

        return definition;
    }

    /**
     * Determina si existe el campo especificado. Dado que todos los hijos de la clase son de tipo
     * {@link Structure.Field} la función es equivalente a {@link Structure.Container#hasElement}
     * @param  {string}  fieldId ID del campo a buscar
     * @return {Boolean}         Si existe el campo en la estructura del contenedor
     */
    hasField(fieldId) {
        return this.hasElement(fieldId);
    }

    /**
     * Determina si el contenedor contiene algún campo
     *
     * @return {boolean} Verdadero si hay algún campo definido en la estructura dentro del objeto contenedor
     */
    hasFields() {
        return this.getChildren().length > 0;
    }

    /**
     * Obtiene el campo especificado por su ID. Dado que todos los hijos de la clase son de tipo {@link Structure.Field}
     * la función es equivalente a {@link Structure.Container#getElement}
     * @param  {string}     fieldId ID del campo a obtener
     * @return {Field|null}         Campo encontrado, o null si no se encuentra en la estructura
     */
    getField(fieldId) {
        return this.getElement(fieldId);
    }

    /**
     * Obtiene todos los campos contenidos en el objeto, incluyendo aquellos que son subvariables
     * @return {Field[]} Lista de objetos de campo
     */
    getDescendants() {
        return this.getAllElements();
    }
}

module.exports = FieldsContainer;
